<template lang="html">
  <div class="">

    <div class="type">
      <tl-select label="Location" labelText="name" name="location" :v-model="formData.selectedLocation" :options="locations" @change="(val) => locationSelected(val)"
      />
    </div>

    <div class="">
      <div class="align-filters">
        <button class="filters" v-for="(item, index) in selectedLocations" :key="index">
          <span> {{item.name}} </span>
          <img src="@/assets/group-6.svg" @click="removeTag(index)" />
        </button>
      </div>
    </div>

    <div class="type">
      <tl-select label="Select Quarter" labelText="name" name="quarter" :v-model="formData.selectedQuarter" :options="quarterList"
        @change="(val) => quarterSelected(val)" />
    </div>

    <div class="margin-top-20">
      <div class="customSingleColumnGrid">
        <tl-checkbox label="Include Zero TDS employees" name="includeZeroTDSemployee" :checked="formData.includeZeroTDSemployee"
          v-model="formData.includeZeroTDSemployee"></tl-checkbox>
        <tl-checkbox label="Include Non PAN employees" name="includeNonPANemployee" :checked="formData.includeNonPANemployee" v-model="formData.includeNonPANemployee"></tl-checkbox>
        <tl-checkbox label="Change in LE address from the last return" name="changeInLEaddress" :checked="formData.changeInLEaddress"
          v-model="formData.changeInLEaddress"></tl-checkbox>
        <tl-checkbox label="Change in the address of the responsible person from last return" name="changeInAddressOfRespPerson"
          :checked="formData.changeInAddressOfRespPerson" v-model="formData.changeInAddressOfRespPerson"></tl-checkbox>
      </div>
    </div>

    <div class="margin-top-35">
      <label class="download-text">Download As</label>
    </div>

    <div class="row margin-top-20">
      <tl-radio class="col-2" label="Text File" name="downloadType" id="text_file" value="text" @change="(val)=>downloadType=val"
      />
      <tl-radio class="col-2" label="Excell Sheet" name="downloadType" id="excell_sheet" value="excell" @change="(val)=>downloadType=val"
      />
    </div>

    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn v-if="downloadType == 'text'" text="View" type="secondary" @click="view()" />
          <btn text="Download" type="primary" @click="download()" />
        </btn-grp>
      </template>
    </bottom-action-container>

    <pop-up-message v-if="showModal" :message="`“ File Validation Tool “ required to Validate 24Q text report. `" popupHeaderMessage="Report 24Q Successfully Downloaded." btnText="Ok" @back="okbtn()">
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancel()">Cancel</button>
          <button class="btn-popup" type="button" @click="downloadTool()">Download Tool</button>
        </div>
      </template>
    </pop-up-message>

  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    name: "twentyFourQReport",
    computed: {
      ...mapState({}),
      ...mapGetters({
        orgid: "onboard/organization/orgid"
      })
    },
    data() {
      return {
        showModal: false,
        locations: [
          { id: 1, name: "Bangalore" },
          { id: 2, name: "Hyderabad" },
          { id: 3, name: "Mumbai" },
          { id: 4, name: "Chennai" }
        ],
        selectedLocations: [
          { id: 1, name: "Bangalore" },
          { id: 2, name: "Hyderabad" }
        ],
        quarterList: [
          { id: 1, name: "Q 1" },
          { id: 2, name: "Q 2" },
          { id: 3, name: "Q 3" },
          { id: 4, name: "Q 4" }
        ],

        formData: {
          selectedLocation: {},
          selectedQuarter: {},
          includeZeroTDSemployee: false,
          includeNonPANemployee: false,
          changeInLEaddress: false,
          changeInAddressOfRespPerson: false
        },

        downloadType: ""
      };
    },
    mounted() { },

    methods: {
      ...mapActions({}),

      removeTag(index) {
        this.selectedLocations.splice(1, index);
        //console.log("selectedLocations", this.selectedLocations);
      },

      locationSelected(val) {
        //console.log("locationSelected:", val);
      },

      quarterSelected(val) { },

      view() { },

      download() {
        this.showModal = true;
      },

      okbtn() {
        this.showModal = false;
      },

      cancel(){
        this.showModal = false;
      },

      downloadTool(){
        this.showModal = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .margin-top-20 {
    margin-top: 20px;
  }

  .margin-top-35 {
    margin-top: 3.5%;
  }

  .margin-top-20 {
    margin-top: 20px;
  }

  .type {
    display: flex;
    margin-top: 30px;
    div {
      width: 250px;
      padding-right: 20px;
    }
  }

  .subtype {
    margin-top: 25px;
  }

  .tl-select-dropdown {
    margin-bottom: 0px !important;
  }

  .align-filters {
    display: flex;
    margin: 0px 0 0 -10px;
    *:nth-child(1) {
      text-align: center;
    }
    button {
      border-radius: 100px;
      background-color: #b2f8f7;
    }
  }

  .filters {
    width: 125px;
    height: 28px;
    display: flex;
    justify-content: space-between;
    margin-left: 10px;
    *:nth-child(1) {
      margin-right: 10px;
      padding-left: 5px;
    }
    img {
      margin-top: 3px;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .customSingleColumnGrid {
    display: grid;
    grid: auto;
    grid-row-gap: 30px;
  }

  .download-text {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    color: #646464;
  }
</style>
